import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import { Toastcontainer5, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import axios from 'axios';
import moment from 'moment';
import { isMobile } from 'react-device-detect';

const pageingState = {
  gotoPage: 1,
  pageCount: 0,
  con: 0,
};
const ReserveList = (props) => {
  const { loginId, apiUrl, pkg, history, icon, nicName, imgUrl } = props;
  const [payList, setPayList] = useState([]);
  const [infoData, setInfoData] = useState([]);
  const [page, setPage] = useState(pageingState);

  const _getData = async (gotoPage) => {
    const result = await axios.post(apiUrl + '/exhibitionList', {
      userid: loginId,
      pkg: pkg,
      gotoPage: gotoPage,
      pageSize: 3,
    });

    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const infoData = result.data[0].infoData;
    const listData = result.data[0].listData;
    if (intReturn === 0) {
      setPayList(listData);
      setInfoData(infoData);
      setPage({
        ...page,
        gotoPage,
        con,
        pageCount,
      });
    }
  };

  const _detail = (orderCode) => {
    const { history } = props;
    history.push(`/reserve/${orderCode}`);
  };

  const _reserve = () => {
    const { history } = props;
    history.push('/reserve');
  };
  const _onPrev = () => {
    const { gotoPage } = page;
    if (gotoPage === 1) {
      toast.warn('페이지의 처음입니다.');
    } else {
      _getData(gotoPage - 1);
    }
  };
  const _onNext = () => {
    const { gotoPage, pageCount } = page;
    if (gotoPage + 1 > pageCount) {
      toast.warn('페이지의 마지막입니다.');
    } else {
      _getData(gotoPage + 1);
    }
  };
  const _prevEnd = () => {
    _getData(1);
  };
  const _nextEnd = () => {
    const { gotoPage, pageCount } = page;
    _getData(pageCount);
  };
  const _ReanerPage = () => {
    const { gotoPage, con, pageCount } = page;
    const dataPerPage = 3;
    console.log(gotoPage, con, pageCount);
    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }
    const list = pageNumbers.map((num, index) => {
      return (
        <li key={index} className={gotoPage === num ? 'active' : null}>
          <a onClick={() => _getData(num)} style={{ cursor: 'pointer' }}>
            {num}
          </a>
        </li>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <>
        <button type="button" className="btn_first" onClick={() => _prevEnd()}>
          맨처음
        </button>
        <button type="button" className="btn_prev" onClick={() => _onPrev()}>
          이전
        </button>
        <ul>{list}</ul>
        <button type="button" className="btn_next" onClick={() => _onNext()}>
          다음
        </button>
        <button type="button" className="btn_last" onClick={() => _nextEnd()}>
          마지막
        </button>
      </>
    );
  };
  const CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  const _back = () => {
    history.push('/event/323');
  };
  useEffect(() => {
    if (loginId === null || loginId === undefined || loginId === '') {
      history.push('/login');
    } else {
      _getData(1);
    }
  }, []);

  console.log(infoData);
  console.log(payList);

  if (payList.length <= 0) {
    // toast.warn('예매내역이 존재하지 않습니다.');
  }

  return (
    <div id="wrap">
      <a className="close" onClick={_back} style={{ cursor: 'pointer' }}></a>
      {/* <!-- 컨텐츠영역 --> */}
      <section className="container5 tiket3">
        {/* <!-- 왼쪽 컨텐츠 --> */}
        <div className="bx">
          <h1>
            <img src={imgUrl + '/img/mediaArt/logo.svg'} alt="" />
          </h1>
          <div className="profile">
            <div className="profile_img">
              <img src={icon} alt="" />
            </div>
            <div className="name">{nicName}님</div>
            <div className="etc">총 {page.con}건 예매</div>
          </div>
          {!isMobile && (
            <div className="section sec_item sec_item2">
              <div className="item">
                <div className="thumb">
                  <img src={infoData.length > 0 && infoData[0].img} alt="" />
                </div>
                <ul>
                  <li>
                    <span className="tit">작품명</span>
                    <span className="txt">
                      {infoData.length > 0 && infoData[0].exhibitionName}
                    </span>
                  </li>
                  <li>
                    <span className="tit">기간</span>
                    <span className="txt">
                      {infoData.length > 0 &&
                        moment(infoData[0].startDate).format('YYYY.MM.DD')}{' '}
                      ~{' '}
                      {infoData.length > 0 &&
                        moment(infoData[0].endDate).format('YYYY.MM.DD')}
                    </span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">
                      {infoData.length > 0 &&
                        infoData[0].exhibitionLocationName}
                    </span>
                  </li>
                  <li>
                    <span className="tit">등급</span>
                    <span className="txt">
                      {infoData.length > 0 && infoData[0].grade}
                    </span>
                  </li>
                  <li>
                    <span className="tit">관람시간</span>
                    <span className="txt">
                      {infoData.length > 0 && infoData[0].playTime}
                    </span>
                  </li>
                  <li>
                    <span className="tit">예매금액</span>
                    <span className="txt">
                      {infoData.length > 0 && CommaFormatted(infoData[0].price)}
                      원{' '}
                      {infoData.length > 0 && infoData.early === 'Y'
                        ? ' (얼리버드)'
                        : ''}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
        {/* <!-- 오른쪽 컨텐츠 --> */}
        <div className="bx">
          <div className="section sec_item sec_reserve">
            {payList.map((item, index) => {
              return (
                <div
                  className="item"
                  onClick={() => _detail(item.orderCode)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="item_top">
                    <span className="day">
                      예매일
                      <span> {moment(item.regDate).format('YYYY.MM.DD')}</span>
                    </span>
                    {item.chkTicket === 'Y' && (
                      <a className="bttn bttn_end">발권승인 완료</a>
                    )}
                    {item.cancel && <a className="bttn">예매취소 완료</a>}
                  </div>
                  <div className="item_cont">
                    <div className="thumb">
                      <img
                        src={infoData.length > 0 && infoData[0].img}
                        alt=""
                      />
                    </div>
                    <ul>
                      <li>
                        <span className="tit">작품명</span>
                        <span className="txt">
                          {infoData.length > 0 && infoData[0].exhibitionName}
                        </span>
                      </li>
                      <li>
                        <span className="tit">장소</span>
                        <span className="txt">
                          {' '}
                          {infoData.length > 0 &&
                            infoData[0].exhibitionLocationName}
                        </span>
                      </li>
                      <li>
                        <span className="tit">날짜</span>
                        <span className="txt">
                          {' '}
                          {moment(
                            item.rdate.toString().substring(0, 4) +
                              '-' +
                              item.rdate.toString().substring(4, 6) +
                              '-' +
                              item.rdate.toString().substring(6, 8)
                          ).format('YYYY.MM.DD(dd)')}
                        </span>
                      </li>
                      <li>
                        <span className="tit">시간</span>
                        <span className="txt">{item.rtimeName}</span>
                      </li>
                      <li>
                        <span className="tit">예매수량</span>
                        <span className="txt">{item.rcount}매</span>
                      </li>
                      <li>
                        <span className="tit">결제금액</span>
                        <span className="txt">
                          {CommaFormatted(item.price)}원{' '}
                          {item.early === 'Y' ? ' (얼리버드)' : ''}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            })}

            {/* <div className="item">
              <div className="item_top">
                <span className="day">
                  예매일<span>2023.05.06</span>
                </span>
                <a href="#" className="bttn bttn_end">
                  발권승인 완료
                </a>
              </div>
              <div className="item_cont">
                <div className="thumb">
                  <img src="/img/mediaArt/img_wrap.jpg" alt="" />
                </div>

                <ul>
                  <li>
                    <span className="tit">작품명</span>
                    <span className="txt">앙상블 스타즈</span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">명동 그라운드 시소</span>
                  </li>
                  <li>
                    <span className="tit">날짜</span>
                    <span className="txt">2023.09.20</span>
                  </li>
                  <li>
                    <span className="tit">시간</span>
                    <span className="txt">2회 오후 12시 00분</span>
                  </li>
                  <li>
                    <span className="tit">결제금액</span>
                    <span className="txt">70,000원</span>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
          <div className="paging">
            <_ReanerPage />
            {/* <button type="button" className="btn_first">
              맨처음
            </button>
            <button type="button" className="btn_prev">
              이전
            </button>
            <ul>
              <li className="active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
            </ul>
            <button type="button" className="btn_next">
              다음
            </button>
            <button type="button" className="btn_last">
              마지막
            </button> */}
          </div>
        </div>
      </section>
    </div>

    // <div className="content">
    //   <div style={{ backgroundColor: "#fff" }}>
    //     <div onClick={_reserve}>예매하기</div>
    //     <div>
    //       {payList.map((item, index) => {
    //         return (
    //           <div>
    //             <span onClick={() => _detail(item.orderCode)}>
    //               {item.rdate}|{item.rtime}|{item.rcount}|{item.price} |{" "}
    //             </span>

    //             {item.chkTicket === "Y" ? (
    //               <span>발권완료</span>
    //             ) : item.cancel === false ? (
    //               <span></span>
    //             ) : (
    //               <span>취소완료</span>
    //             )}
    //           </div>
    //         );
    //       })}
    //     </div>
    //   </div>
    // </div>
  );
};

export default shopContext(withRouter(ReserveList));
